<template>
    <div class="col-12 pl-2 pr-2 h-100">
      <div class="row no-gutters">
        <b-pagination class="col-8 offset-2"
            v-model="currentPageTop"
            :total-rows="getRow"
            :per-page="selectPerPage"
            aria-controls="AppContactTable"
            align="center"
            limit="15"
            @input="handlePaginatorClick"
        ></b-pagination>
        <div class="col-2 text-right">
          Numero risultati:
          <b-form-select
              id="per-page-select"
              v-model="selectPerPage"
              :options="pageOptions"
              size="sm"
              @change="updatePerPage"
              class="w-auto"
          ></b-form-select>
        </div>
      </div>
        <b-table
            :items="contacts"
            :fields="fields"
            :current-page="currentPageIndex"
            :per-page="selectPerPage"
            stacked="md"
            show-empty
            small
            striped
            id="AppContactTable"
            thead-tr-class="m-table"
            ref="contactTable"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            @sort-changed="updateSort"
            sort-icon-left
        >
            <b-tr class="d-md-none"></b-tr>
            <template #cell(selection)="row" :class="{ 'text-black-50' : row.item.status !== 'ENABLED'}">

                <span v-if="row.item.status === 'ENABLED'">
                    <input
                        type="checkbox"
                        v-model="row.item.selection"
                        :checked="selectRow"/>
                </span>

                <span v-else>
                    <input type="checkbox" v-model="row.item.selection" disabled/>
                </span>
            </template>

            <template #cell(person.lastName)="row">
                {{ row.item.title }}
            </template>

            <template #head(email)>
              Email | <span class="text-muted">Numero</span>
            </template>
            <template #cell(email)="row">
                {{ row.item.email }}
                <div class="text-muted" v-if="row.item.tel">{{row.item.tel}}</div>
            </template>

            <template #cell(course)="row">
                <div class="d-flex" v-if="row.item.course">
                    <!--  {{row.item.status}} -->
<!--                    <span v-for="(code, index) in row.item.contactsCourses" :key="code.id">-->
<!--                        <div v-if="index <= 0">-->
                            <small>
<!--                                {{ typeCourseById(code.idCourse) }}-->
                                {{ typeCourseById(row.item.course) }}
                            </small>
<!--                        </div>-->
<!--                    </span>-->
                </div>
            </template>

            <template #cell(activity)="row">
                <div class="d-flex" v-if="row.item?.activities">
                    <div class="d-flex" v-if="row.item.activities.length > 0">
<!--                        orderActivitiesContacts(row.item.contactsActivities)-->
                        <span :class="{ 'text-black-50' : row.item.status !== 'ENABLED'}" v-for="(activity, index) in (row.item?.activities || [])" :key="activity.id + '-' + index">
                            <div v-if="index <= 2">
                                <b-badge class="m-badge ml-1" :class="{ 'text-black-50' : row.item.status !== 'ENABLED'}">
                                    <span>
                                    {{ activityTypeCodeById(activity.id) }}
                                    </span>
                                </b-badge>
                            </div>
                        </span>
                    </div>

                    <div class="d-flex ml-1" v-if="row.item.activities && row.item.activities.length > 3">
                        <b-badge class="m-badge">
                            <span>+{{ row.item.activities.length - 3 }}</span>
                        </b-badge>
                    </div>
                </div>
            </template>

          <template #head(lastDirectContact.elapsedValue)>
            Ultima Attività | <span class="font-italic">Nota</span> | <span class="text-muted font-italic">Ultimo contatto diretto</span>
          </template>
            <template #cell(lastDirectContact.elapsedValue)="row">
                <span v-if="row.item.lastActivity">
                    {{ LastActivityNameById(row.item.lastActivity) }}
                </span>
                <span v-if="row.item.lastDirectContact?.elapsed" class="float-right font-italic text-muted">
                    {{ row.item.lastDirectContact?.elapsed }}
                </span>

                <span v-if="row.item.notes !== ''" class="font-italic">
                    <hr class="mt-0 mb-0" />
                    <small><b v-html="row.item.note"></b></small>
                </span>

            </template>

            <template #cell(mcStatus)="row">
                <div class="d-flex justify-content-center">
                  <span v-b-tooltip.hover.html="row.item.mcTooltip"><!--Add mcUpdateTimestamp?-->
                    <!--Unknown-->
                    <b-icon v-if="row.item.mcStatus === 0"
                            class="text-black-50"
                            icon="dash-square"
                            scale="2"
                            font-scale="0.7"
                            variant="secondary"
                    ></b-icon>
                    <!--Synced-->
                    <b-icon v-else-if="row.item.mcStatus === 1"
                            icon="check-square"
                            scale="2"
                            font-scale="0.7"
                            variant="success"
                    ></b-icon>
                    <!--Compliance-->
                    <b-icon v-else-if="row.item.mcStatus === 2"
                            icon="info-square"
                            scale="2"
                            font-scale="0.7"
                            variant="warning"
                    ></b-icon>
                    <!--Unsupported-->
                    <b-icon v-else-if="row.item.mcStatus === 3"
                            icon="info-square"
                            scale="2"
                            font-scale="0.7"
                            variant="info"
                    ></b-icon>
                    <!--Error-->
                    <b-icon v-else-if="row.item.mcStatus === 4"
                            icon="exclamation-square-fill"
                            scale="2"
                            font-scale="0.7"
                            variant="danger"
                    ></b-icon>
                    <b-icon v-else
                            icon="question-square"
                            scale="2"
                            font-scale="0.7"
                            variant="info"
                    ></b-icon>
                  </span>
                </div>
            </template>

            <template #cell(newsletter)="row">
                <div class="d-flex justify-content-center">
                    <span v-if="row.item.isNewsletter == true">
                        <b-icon
                            :class="{ 'text-black-50' : row.item.status !== 'ENABLED'}"
                            icon="check-square"
                            scale="2"
                            font-scale="0.7"
                            variant="success"
                        ></b-icon>
                    </span>
                    <span v-else>
                        <b-icon
                            :class="{ 'text-black-50' : row.item.status !== 'ENABLED'}"
                            icon="x-square"
                            scale="2"
                            font-scale="0.7"
                            variant="danger"
                        ></b-icon>
                    </span>
                </div>
            </template>

            <template #cell(actions)="row">
                <span v-if="row.item.status === 'ENABLED'">
                    <b-button
                        size="sm"
                        :to="{
                            name: 'DettagliContatto',
                            query: { id: row.item.id },
                        }"
                        class="mr-1"
                    >
                        Dettagli
                    </b-button>
                </span>
                <span v-else>
                    Archiviato
                </span>
            </template>
        </b-table>

      <div class="row no-gutters">
        <b-pagination class="col-8 offset-2"
            v-model="currentPageBottom"
            :total-rows="getRow"
            :per-page="selectPerPage"
            aria-controls="AppContactTable"
            align="center"
            limit="15"
            @input="handlePaginatorClick"
        ></b-pagination>
        <div class="col-2 text-right">
          Numero risultati:
          <b-form-select
              id="per-page-select"
              v-model="selectPerPage"
              :options="pageOptions"
              size="sm"
              @change="updatePerPage"
              class="w-auto"
          ></b-form-select>
        </div>
      </div>
    </div>
</template>

<script>
import {mapActions} from "vuex";
import moment from "moment";

export default {
    props: ["getItems", "activities", "activityTypes", "getRow", "changePage", "refresh", "selectRow", "selectPerPage", "currentPage"],
    name: "AppContactsTable",
    data() {
        return {
          pageOptions: [10, 20, 50, 100, 300, 500],
          currentPageIndex: this.currentPage || 1,
          currentPageTop: this.currentPage || 1,
          currentPageBottom: this.currentPage || 1,
            fields: [
                {
                    key: "selection",
                    label: "",
                    sortable: false,
                    // thClass: "",
                    // tdClass: "d-flex justify-content-start ",
                },
                {
                    key: "title",
                    label: "Nome Cognome",
                    sortable: true,
                },
                {
                    key: "email",
                    label: "Email | Numero",
                    sortable: true,
                },
                /*{
                    key: "tel",
                    label: "Numero",
                    sortable: false,
                },*/
                {
                    key: "course",
                    label: "Corso interesse",
                    sortable: true,
                },
                {
                    key: "activity",
                    label: "Tipologia Attività",
                    sortable: false,
                },
                {
                    key: "lastDirectContact.elapsedValue",
                    label: "Ultima Attività | Ultimo contatto diretto | Nota",
                    sortable: true,
                },
                {
                    key: "mcStatus",
                    label: "MC",
                    sortable: true,
                },
                {
                    key: "newsletter",
                    label: "Newsletter",
                    sortable: false,
                },
                {
                    key: "actions",
                    label: "",
                    sortable: false,
                    thClass: "",
                    tdClass: "d-flex justify-content-end ",
                },
            ],

            sortBy: "Ord",
            sortDesc: false,
            totalRows: 1,
        };
    },
    created() {
        this.syncSort()
    },

  computed: {
      contacts() {
        /*
         * Add last direct contact metadata to loaded contacts.
         * Last direct contact is based on the "isDirectContact" activity flag set on the activity type.
         * This require resolving both the activity and it's type object to fully compute the metadata.
         */
        const activities = this.activities;
        const activityTypes = this.activityTypes;
        const typeMap = {};
        for (let type of activityTypes)
          typeMap[type.activity.id] = type.activity;
        const map = {};
        for (let activityNode of activities)
          // map[value.activity.id] = value.hasChildren ? value.activity : nodeMap[value.idParent]?.activity || value.activity;
          map[activityNode.activity.id] = {
            type: typeMap[activityNode.activity.activityType_Id],
            activity: activityNode.activity
          };
        const contacts = this.getItems;
        try {
          const now = moment();
          for (let contact of contacts) {
            if (contact.lastDirectContact?.elapsedValue || !contact.activities)
              continue;
            let lastDirectContact = null;
            for(let { id, eventDt } of contact.activities){
              const ref = map[id];
              if (!ref)
                continue;
              const {type, activity} = ref;
              const timestamp = activity && eventDt && moment(eventDt);
              if (activity && timestamp && type.isDirectContact
                  && (!lastDirectContact || timestamp.isAfter(lastDirectContact.timestamp)))
                lastDirectContact = {timestamp, activity, elapsed: timestamp.from(now), elapsedValue: now.diff(timestamp)};
            }
            contact.lastDirectContact = lastDirectContact || {elapsed: 'Nessun contatto', elapsedValue: 365 * 24 * 60 * 60 * 1000}; // 1y
          }
        } catch (e) {
          console.error(e);
          this.$bvToast.toast("Errore durante il calcolo degli ultimi contatti diretti. I dati visualizzati potrebbero non essere completi. ", {
            title: "Errore caricamento dati",
            toaster: "b-toaster-bottom-right",
            solid: true,
            variant: "danger",
            appendToast: true,
          });
        }

        /*
         * Add default mailchimp message
         */
        for (let contact of contacts) {
          if (!contact.mcMessage)
            switch (contact.mcStatus) {
              case 0:
                contact.mcMessage = "Accodato/Non sincronizzato";
                break;
              case 1:
                contact.mcMessage = "Sincronizzato correttamente";
                break;
              case 2:
                contact.mcMessage = "Disiscritto da mailchimp";
                break;
              case 3:
                contact.mcMessage = "Stato mailchimp trovato non gestito";
                break;
              case 4:
                contact.mcMessage = "Errore di sincronizzazione";
                break;
              default:
                contact.mcMessage = "/!\\ Stato non supportato /!\\";
                break;
            }
          if (!contact.mcTooltip) {
            const d = contact.mcUpdateTimestamp instanceof Date ? contact.mcUpdateTimestamp : new Date(contact.mcUpdateTimestamp);
            contact.mcTooltip = `<i><b>${contact.mcMessage}</b></i><br/>
<span class="text-muted">
  Ultimo aggiornamento:<br/>
  <i class="text-muted">${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')} ${d.getDate().toString().padStart(2, '0')}/${(d.getMonth() + 1).toString().padStart(2, '0')}/${d.getFullYear().toString().padStart(4, '0')}</i>
</span>`;
          }
        }
        return contacts;
      }
  },

    methods: {
        ...mapActions(["contact/getContactsPage", "contact/archiveSingleContacts"]),

        handlePaginatorClick(pageNumber) {
        // console.log('handlePaginatorClick', pageNumber);
            if (!isNaN(pageNumber)) {
                this.currentPageIndex = this.currentPageTop = this.currentPageBottom = pageNumber
                localStorage.setItem("contactsCurrentPage", pageNumber);
            }
        },

        syncSort() {
          if (localStorage.getItem("contactsCurrentSort")) {
              let sort = JSON.parse(localStorage.getItem("contactsCurrentSort"));
              this.sortBy = sort.sortBy;
              this.sortDesc = sort.sortDesc;
          }
        },

        typeCourseById($id) {
        const courseName = this.$store.getters["courses/typeCourseById"]($id);

        let name = 0;
        if (courseName !== undefined) {
        name = courseName.name;
        } else {
        name = 0;
        }
        return name;
        /* return courseName; */
        },

        LastActivityNameById($lastActivityId) {
            // let activitiesArray = $array;
            // console.log(activitiesArray);
            // const data = [];
            // activitiesArray.forEach((element) => {
            //     data.push({
            //         idActivity: element.idActivity,
            //         // eventDt: new Date(element.eventDt).getTime(),
            //         // note: element.note,
            //     });
            // });

            // function compare(a, b) {
            //     if (
            //         a == undefined ||
            //         b == undefined ||
            //         a.eventDt == undefined ||
            //         b.eventDt == undefined
            //     ) {
            //         return 0;
            //     }
            //     if (new Date(b.eventDt).getTime() < new Date(a.eventDt).getTime()) {
            //         return -1;
            //     }
            //     if (new Date(a.eventDt).getTime() > new Date(b.eventDt).getTime()) {
            //         return 1;
            //     }
            //     return 0;
            // }
            // const sortActivities = data.sort(compare);

            // const activitiesId = sortActivities[0].idActivity;
            // const activityName = this.$store.getters["activity/activityById"](
            //     activitiesId
            // );

            // const activitiesId = $lastActivityId;
            const activityName = this.$store.getters["activity/activityById"](
                $lastActivityId
            );

            // console.log(activitiesId, activityName);

            let name = '';
            if (activityName !== undefined) {
                name = activityName.activity.name;
            } else {
                name = 0;
            }

            return name;
        },

        orderActivitiesContacts($array) {
          let activitiesArray = $array;
          const data = [];
          activitiesArray.forEach((element) => {
              data.push({
                  idActivity: element.idActivity,
                  eventDt: new Date(element.eventDt).getTime(),
              });
          });

          function compare(a, b) {
              if (
                  a == undefined ||
                  b == undefined ||
                  a.eventDt == undefined ||
                  b.eventDt == undefined
              ) {
                  return 0;
              }
              if (new Date(b.eventDt).getTime() < new Date(a.eventDt).getTime()) {
                  return -1;
              }
              if (new Date(a.eventDt).getTime() > new Date(b.eventDt).getTime()) {
                  return 1;
              }
              return 0;
          }

          return data.sort(compare);
        },

        activitiesContactsById($id) {
          const activity = this.$store.getters["contact/activitiesContactsById"](
              $id
          );
          return activity;
        },

        activityTypeCodeById($id) {
          const activityType_Code = this.$store.getters["activity/activityById"](
              $id
          );
          /* const activity = this.$store.getters["activity/activity"]; */
          /*  console.log(activity); */
          let code = 0;
          /*  console.log(activityType_Code); */
          if (
              activityType_Code !== undefined &&
              activityType_Code.activity !== undefined
          ) {
              code = activityType_Code.activity.activityType_Code;
          } else {
              code = 0;
          }
          return code;

          /* return activityType_Code; */
        },

        async archiveRow($id) {
          /*  console.log($id); */
          try {
              await this.$store
                  .dispatch("contact/archiveSingleContacts", {
                      idContact: $id,
                  })
                  .then(() => {
                      this.contact = this.$store.getters["contact/contact"];

                      return this.contact;
                  });
          } catch (e) {
              console.log({message: "Some error archiveSingleContacts"});
          }
        },


      updatePerPage(){
        localStorage.setItem("contactsCurrentPerPage", String(this.selectPerPage));
      },

        updateSort(e) {
            console.log(this.sortBy);

            this.sortBy = e.sortBy;
            this.sortDesc = e.sortDesc;

            let sort = {
                sortBy: this.sortBy,
                sortDesc: this.sortDesc,
            };

            localStorage.setItem("contactsCurrentSort", JSON.stringify(sort));
        },
    },
};
</script>
